import { Expose, Transform } from 'class-transformer';
import { IsBoolean, IsEnum, IsNotEmpty, IsString, IsUUID } from 'class-validator';
import { MfaType } from '../../enums/auth';

export class MfaMethodResponseDto {
    @Expose()
    @IsUUID()
    @IsNotEmpty()
    id: string;

    @Expose()
    @IsEnum(MfaType)
    @IsNotEmpty()
    type: MfaType;

    @Expose()
    @IsString()
    @Transform(({ value, obj }) => {
        if (obj.type === MfaType.SMS && value) {
            const suffix = value.substring(value.length - 3);
            const maskedPart = '*'.repeat(value.length - 3);
            return `${maskedPart}${suffix}`;
        }
        return value;
    })
    identifier: string;

    @Expose()
    @IsString()
    status: string;

    @Expose()
    @IsBoolean()
    isDefault: boolean;

    @Expose()
    @IsString()
    lastVerifiedAt: Date | null;

    @Expose()
    @IsString()
    createdAt: Date;
}
